import { render, staticRenderFns } from "./ClienteMain.vue?vue&type=template&id=7aefeebd&"
import script from "./ClienteMain.vue?vue&type=script&lang=js&"
export * from "./ClienteMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports